import { Controller } from "stimulus";
import { Chart, ArcElement, DoughnutController, Tooltip, LinearScale } from "chart.js";

Chart.register(ArcElement, DoughnutController, Tooltip, LinearScale);

export default class extends Controller {
  static targets = ["chart", "gray", "yellow", "green"];

  connect() {
    if (this.chartTarget.classList.contains("chartjs-render-monitor")) {
      const chartId = this.chartTarget.dataset.chartId;
      const chart = Chart.instances[chartId];
      chart.data.datasets = this._chartConfig().data.datasets;
      chart.update();
    } else {
      this.drawChart();
      this.chartTarget.classList.add("chartjs-render-monitor");
    }
  }

  drawChart() {
    const chart = new Chart(this.chartTarget, this._chartConfig());
    this.chartTarget.dataset.chartId = chart.id;
  }

  _chartConfig() {
    const completedCount = this.data.get("completed");
    const inProgressCount = this.data.get("inprogress");
    const unstartedCount = this.data.get("unstarted");

    const completedLabel = this.data.get("completedLabel");
    const inProgressLabel = this.data.get("inprogressLabel");
    const unstartedLabel = this.data.get("unstartedLabel");

    return {
      type: "doughnut",
      options: {
        events: ['mousemove', 'mouseout'],
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            displayColors: false,
          }
        },
        elements: {
          arc: {
            borderWidth: 0,
          },
        },
        cutout: '60%',
        onHover: (e) => {
          var point = e.chart.getElementsAtEventForMode(e, 'nearest', { intersect: true }, true);

          if (point.length) {
            e.chart.canvas.style.cursor = "pointer";
          } else {
            e.chart.canvas.style.cursor = "default";
          }
        },
        responsive: true,
        aspectRatio: 2
      },
      data: {
        labels: [completedLabel, inProgressLabel, unstartedLabel],
        datasets: [
          {
            data: [completedCount, inProgressCount, unstartedCount],
            backgroundColor: [
              getComputedStyle(this.greenTarget).backgroundColor,
              getComputedStyle(this.yellowTarget).backgroundColor,
              getComputedStyle(this.grayTarget).backgroundColor,
            ],
          },
        ],
      },
    };
  }
}
